module.exports = __webpack_public_path__ + "static/media/geometry-800updatedpx.dc9bd426.png";